import { UserShape } from '../models/user';
import GenericStore from '../classes/generic-store';
import { UserApi } from '../api/user-api';

const readSessionUser = () => {
  const res = UserApi.readSessionUser();
  return res.hasResolved()
    ? res.refetch().then(r => r.data)
    : res.toPromise().then(r => r.data);
};

class UserStoreClass extends GenericStore {
  load(activeDirectorySecurityGroup) {
    return this.setState(
      readSessionUser().then(u => ({
        ...u,
        activeDirectorySecurityGroup,
      }))
    );
  }

  getDataShape() {
    return UserShape;
  }

  select(state) {
    return super.select(state).data || null;
  }

  isAiMatchControlEnabled(user) {
    return user?.settings?.find(
      us => us.name === 'enable-ml-button' && us.value === 'true'
    );
  }
}

export const PreloadedUserStore = new UserStoreClass();
